import API from "..";

async function getLogs(url) {
  try {
    const response = await API.get(url);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { getLogs };
